/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { AccountCollectionResponse as BackendCoreApiModelsIdentityAccountCollectionResponse } from '../models/Backend/Core/Api/Models/Identity/account-collection-response';
import { QueryRequest as BackendCoreApiModelsQueryRequest } from '../models/Backend/Core/Api/Models/query-request';

@Injectable({
  providedIn: 'root',
})
export class SamplesBackendService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation samplesGetDxUsers
   */
  static readonly SamplesGetDxUsersPath = '/api/samples/dx-users';

  /**
   * Get a list of users with Dx DataLoadOptions.
   *
   * Returns with an unknown object :)
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `samplesGetDxUsers$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  samplesGetDxUsers$Plain$Response(params?: {
    body?: BackendCoreApiModelsQueryRequest
  }): Observable<StrictHttpResponse<BackendCoreApiModelsIdentityAccountCollectionResponse>> {

    const rb = new RequestBuilder(this.rootUrl, SamplesBackendService.SamplesGetDxUsersPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BackendCoreApiModelsIdentityAccountCollectionResponse>;
      })
    );
  }

  /**
   * Get a list of users with Dx DataLoadOptions.
   *
   * Returns with an unknown object :)
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `samplesGetDxUsers$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  samplesGetDxUsers$Plain(params?: {
    body?: BackendCoreApiModelsQueryRequest
  }): Observable<BackendCoreApiModelsIdentityAccountCollectionResponse> {

    return this.samplesGetDxUsers$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<BackendCoreApiModelsIdentityAccountCollectionResponse>) => r.body as BackendCoreApiModelsIdentityAccountCollectionResponse)
    );
  }

  /**
   * Get a list of users with Dx DataLoadOptions.
   *
   * Returns with an unknown object :)
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `samplesGetDxUsers$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  samplesGetDxUsers$Json$Response(params?: {
    body?: BackendCoreApiModelsQueryRequest
  }): Observable<StrictHttpResponse<BackendCoreApiModelsIdentityAccountCollectionResponse>> {

    const rb = new RequestBuilder(this.rootUrl, SamplesBackendService.SamplesGetDxUsersPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BackendCoreApiModelsIdentityAccountCollectionResponse>;
      })
    );
  }

  /**
   * Get a list of users with Dx DataLoadOptions.
   *
   * Returns with an unknown object :)
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `samplesGetDxUsers$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  samplesGetDxUsers$Json(params?: {
    body?: BackendCoreApiModelsQueryRequest
  }): Observable<BackendCoreApiModelsIdentityAccountCollectionResponse> {

    return this.samplesGetDxUsers$Json$Response(params).pipe(
      map((r: StrictHttpResponse<BackendCoreApiModelsIdentityAccountCollectionResponse>) => r.body as BackendCoreApiModelsIdentityAccountCollectionResponse)
    );
  }

}
